module.exports = __webpack_public_path__ + "static/img/person-holding-a-smartphone-892757.aeb62aee.jpg";